// @flow
import ResourceModel from "../base/ResourceModel";

import type ModularUIResponse from "../../modularui/ModularUIResponse";

/**
 * Model for concept details, available through modelcatalog
 */
class ConceptTypeDetailModel extends ResourceModel {
  /**
   * The name of the concept type consists of the functional id of the kmt and the functional id of the concept type separated by a #.<br>
   * For example BEI_CaseManagement#Case
   */
  get kmtId(): string {
    return this.getData("kmtId", "");
  }

  /**
   */
  get type(): string {
    return "ConceptTypeDetail";
  }

  /**
   */
  static get modelName(): string {
    return "ConceptTypeDetailModel";
  }

  /**
   */
  static isApplicableModel(data: ModularUIResponse): boolean {
    return (
      data.contributions.resourcetype &&
      data.contributions.resourcetype === "ConceptTypeDetail"
    );
  }

  /**
   */
  get key(): string {
    return this.data._id;
  }

  /**
   * Get concept type label
   */
  get label(): string {
    return this.getData("label", "");
  }

  /**
   * Get model category of the concept type
   */
  get modelCategory(): string {
    return this.getData("modelCategory", "");
  }

  /**
   */
  get isCoreTaxonomy(): boolean {
    return this.getData("coreTaxonomy", "false") === "true";
  }

  /**
   * Get concept type icon
   */
  get icon(): string {
    return this.getData("icon", "");
  }

  /**
   * Get concept type text color
   */
  get textColor(): string {
    return this.getData("textColor", "#000");
  }

  /**
   * Get concept type background color
   */
  get backgroundColor(): string {
    return this.getData("backgroundColor", "#fff");
  }

  /**
   * Get concept line color
   */
  get borderColor(): string {
    return this.getData("lineColor", "#000");
  }

  /**
   * Get label types
   */
  get labelTypes(): ?Array<Object> {
    return this.data.labelTypes;
  }

  /**
   * Get propertyTypes
   */
  get propertyTypes(): Array<Object> {
    return this.getData("propertyTypes", []);
  }

  /**
   * Get textFragmentTypes
   */
  get textFragmentTypes(): Array<Object> {
    return this.getData("textFragmentTypes", []);
  }

  /**
   * Get sectionReferenceTypes
   */
  get sectionReferenceTypes(): Array<Object> {
    return this.getData("sectionReferenceTypes", []);
  }

  /**
   */
  isOfConceptType(conceptTypeId: string): boolean {
    return this.selfhref.equals(conceptTypeId);
  }
}

export default ConceptTypeDetailModel;
